<template>
  <div class="payBill">
    <!-- “payBill”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchCompanyName="searchCompanyName"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- payBill -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :row-style="rowStyle"
        :columns="columnList"
        :showFooter="true"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
          <!-- <template v-slot:content="{ row }">
            <vxe-table
              border
              show-overflow
              resizable
              class="vxe-table-element"
              size="mini"
              align="left"
              min-width="120"
              :auto-resize="true"
              :data="row.acceptanceList ? row.acceptanceList : []"
              max-height="200px"
            >
              <vxe-table-column
                type="seq"
                width="50"
                :title="$t('receivablesManage.receivablesClaimInfo.seq')"
              ></vxe-table-column>
              <vxe-table-column
                field="acceptDate"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.acceptDate')"
              >
              </vxe-table-column>
              <vxe-table-column
                field="acceptAmount"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.acceptAmount')"
              ></vxe-table-column>
              <vxe-table-column
                field="planPayDate"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.planPayDate')"
              >
                <template v-slot="{ row }">{{
                  $utils.toDateString(row.planPayDate, 'yyyy-MM-dd')
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="planPayAmount"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.planPayAmount')"
              ></vxe-table-column>
              <vxe-table-column
                field="planPayExchangeRate"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.planPayExchangeRate')"
              ></vxe-table-column>
              <vxe-table-column
                field="contractNo"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.contractNo')"
              ></vxe-table-column>
              <vxe-table-column
                field="contractDetailNo"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.contractDetailNo')"
              ></vxe-table-column>
              <vxe-table-column
                field="productNo"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.productNo')"
              ></vxe-table-column>
              <vxe-table-column
                field="productDesc"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.productDesc')"
              ></vxe-table-column>
              <vxe-table-column
                field="isRefusePayment"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.isRefusePayment')"
              >
                <template v-slot="{ row }">{{ row.isRefusePayment == 1 ? '是' : '否' }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="refusePaymentDueDate"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.refusePaymentDueDate')"
              ></vxe-table-column>
              <vxe-table-column
                field="isPaid"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.isPaid')"
              >
                <template v-slot="{ row }">{{ row.isPaid == 1 ? '是' : '否' }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="statusFlag"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.statusFlag')"
              >
                <template v-slot="{ row }">{{
                  row.statusFlag | getDictNameByCode('cl-issuing-acceptance')
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="paidAmount"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.paidAmount')"
              ></vxe-table-column>
              <vxe-table-column
                field="unpaidAmount"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.unpaidAmount')"
              ></vxe-table-column>
              <vxe-table-column
                field="delayPaymentType"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.delayPaymentType')"
              >
                <template v-slot="{ row }">{{
                  getDelayPaymentType(row.delayPaymentType)
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="isLockExchangeRate"
                width="150"
                :title="$t('tFundCreditLetterAcceptance.column.isLockExchangeRate')"
              >
                <template v-slot="{ row }">{{
                  row.isLockExchangeRate == 1 ? '是' : '否'
                }}</template>
              </vxe-table-column>
            </vxe-table>
          </template> -->
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      ref="SiruiUpload"
      @getData="getData"
      :data="{ ...tokenInfo }"
    ></sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalCenter/letterOfCredit';
  import BASE_API from '@/api/dataBase.js';
  // import COM_API from '@/api/masterData/company.js';
  import tableMixins from '@/common/mixins/table.js';
  import siruiUpload from '@/components/SiruiUpload';
  import loading from '@/common/js/load.js'; //loading
  export default {
    name: 'searchIssueCredit',
    mixins: [tableMixins],
    components: {
      siruiUpload,
    },
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            name: this.$t('searchIssueCredit.search.companyCode'),
            prop: 'businessCompanyCode',
            type: 'select',
            placeholder: this.$t('searchIssueCredit.search.companyCodePlaceholder'),
            options: this.companyList,
            changeMethod: 'searchCompanyName',
            clearable: true,
          },
          {
            name: this.$t('searchIssueCredit.search.departmentCodes'),
            prop: 'departmentCode',
            type: 'select',
            options: this.departmentList,
          },
          {
            name: this.$t('searchIssueCredit.search.applyDateStart'),
            prop: 'applyDateStart',
            type: 'startDaterangePicker',
            placeholder: this.$t('searchIssueCredit.search.applyDateStartPlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.applyDateEnd'),
            prop: 'applyDateEnd',
            type: 'endDaterangePicker',
            placeholder: this.$t('searchIssueCredit.search.applyDateEndPlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.applyNo'),
            prop: 'applyNo',
            type: 'input',
            placeholder: this.$t('searchIssueCredit.search.applyNoPlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.partnerCodes'),
            prop: 'beneficiary',
            type: 'searchTableSpec',
            searchType: 'supplier',
            extraData: {
              companyCode: this.query.businessCompanyCode,
              departmentCode: this.query.businessDepartmentCode,
            },
            isMultiple: true,
            isNeedMultipleValue: false,
          },
          {
            name: this.$t('searchIssueCredit.search.applyUserName'),
            prop: 'applyUserName',
            type: 'input',
            placeholder: this.$t('searchIssueCredit.search.applyUserNamePlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.clCode'),
            prop: 'clCode',
            type: 'input',
            placeholder: this.$t('searchIssueCredit.search.clCodePlaceholder'),
          },
          // 开征申请金额
          {
            type: 'inputRange',
            prop: ['applyClAmountMin', 'applyClAmountMax'],
            precision: this.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
            name: this.$t('searchIssueCredit.search.applyClAmount'),
            span: 12,
          },
          {
            name: this.$t('searchIssueCredit.search.clType'),
            prop: 'clType',
            type: 'dict',
            dictType: 'cl-clType',
            placeholder: this.$t('searchIssueCredit.search.clTypePlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.bankId'),
            prop: 'branchCode',
            placeholder: this.$t('searchIssueCredit.search.bankIdPlaceholder'),
            type: 'searchTableSpec',
            searchType: 'bankAccountBranchName',
            isMultiple: true,
            isNeedMultipleValue: false,
          },
          {
            name: this.$t('searchIssueCredit.search.currencyCode'),
            prop: 'currencyCode',
            type: 'dict',
            dictType: 'all_currency',
            placeholder: this.$t('searchIssueCredit.search.currencyCodePlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.acceptDateStart'),
            prop: 'acceptDateBefore',
            type: 'startDaterangePicker',
            placeholder: this.$t('searchIssueCredit.search.acceptDateStartPlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.acceptDateEnd'),
            prop: 'acceptDateAfter',
            type: 'endDaterangePicker',
            placeholder: this.$t('searchIssueCredit.search.acceptDateEndPlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.statusFlag'),
            prop: 'statusFlag',
            type: 'dict',
            dictType: 'cl-status-flag',
            placeholder: this.$t('searchIssueCredit.search.statusFlagPlaceholder'),
          },
          // 承兑状态改为承兑&协议状态
          {
            name: this.$t('承兑&议付状态'),
            prop: 'acceptNegotiationStatus',
            type: 'dict',
            dictType: 'accept-negotiation',
            placeholder: this.$t('searchIssueCredit.search.accStatusFlagPlaceholder'),
          },
          // 入账状态取消
          // {
          //   name: this.$t('searchIssueCredit.search.accountStatus'),
          //   prop: 'accountStatus',
          //   type: 'dict',
          //   dictType: 'post_status',
          //   placeholder: this.$t('searchIssueCredit.search.accountStatusPlaceholder'),
          // },
          // 应付汇日期从
          {
            name: '议付日期从',
            prop: 'negotiationDateStart',
            type: 'startDaterangePicker',
            placeholder: this.$t('searchIssueCredit.search.paymentDateStartPlaceholder'),
          },
          {
            name: '议付日期到',
            prop: 'negotiationDateEnd',
            type: 'endDaterangePicker',
            placeholder: this.$t('searchIssueCredit.search.paymentDateEndPlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.issueType'),
            prop: 'issueType',
            type: 'dict',
            dictType: 'cl-issueType',
            placeholder: this.$t('searchIssueCredit.search.issueTypePlaceholder'),
          },
          {
            type: 'input',
            prop: 'contractNo',
            name: '合同号',
          },
          // {
          //   label: this.$t('searchIssueCredit.search.isAccpetComplete'),
          //   prop: 'isAccpetComplete',
          //   type: 'checkbox',
          // },
          // {
          //   label: this.$t('searchIssueCredit.search.isPayComplete'),
          //   prop: 'isPayComplete',
          //   type: 'checkbox',
          // },
          // {
          //   label: this.$t('searchIssueCredit.search.delayPaymentType1'),
          //   prop: 'delayPaymentType1',
          //   type: 'checkbox',
          // },
          // {
          //   label: this.$t('searchIssueCredit.search.delayPaymentType2'),
          //   prop: 'delayPaymentType2',
          //   type: 'checkbox',
          // },
          // {
          //   label: this.$t('searchIssueCredit.search.delayPaymentType3'),
          //   prop: 'delayPaymentType3',
          //   type: 'checkbox',
          // },

          // {
          //   label: this.$t('searchIssueCredit.search.accIsLockExchangeRate'),
          //   prop: 'accIsLockExchangeRate',
          //   type: 'checkbox',
          // },
          // {
          //   label: this.$t('searchIssueCredit.search.isLockExchangeRate'),
          //   prop: 'isLockExchangeRate',
          //   type: 'checkbox',
          // },
          // { label: '未押汇', prop: 'unDelayPayment', type: 'checkbox' },

          {
            type: 'inputRange',
            prop: ['acceptAmountMin', 'acceptAmountMax'],
            precision: this.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
            name: this.$t('searchIssueCredit.search.acceptAmount'),
            span: 12,
          },
          {
            type: 'inputRange',
            prop: ['clAmountMin', 'clAmountMax'],
            precision: this.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
            name: this.$t('searchIssueCredit.search.clAmount'),
            span: 12,
          },
          // {
          //   prop: 'voucherCode',
          //   name: '凭证号',
          //   type: 'input',
          //   placeholder: this.$t('请输入凭证号'),
          // },
          {
            name: '撤销日期从',
            prop: 'revocationDateStart',
            type: 'startDaterangePicker',
            placeholder: '请选择撤销日期',
          },
          {
            name: '撤销日期至',
            prop: 'revocationDateEnd',
            type: 'endDaterangePicker',
            placeholder: '请选择撤销日期',
          },
          // 开证日期
          {
            name: this.$t('searchIssueCredit.search.issueDateStart'),
            prop: 'issueDateStart',
            type: 'startDaterangePicker',
            placeholder: this.$t('searchIssueCredit.search.issueDateStartPlaceholder'),
          },
          {
            name: this.$t('searchIssueCredit.search.issueDateEnd'),
            prop: 'issueDateEnd',
            type: 'endDaterangePicker',
            placeholder: this.$t('searchIssueCredit.search.issueDateEndPlaceholder'),
          },
        ];
      },
      ...mapState({
        tokenInfo() {
          return {
            access_token: this.userInfo.userInfo.access_token,
            companyCode: this.userInfo.userInfo.companyCode,
            companyName: this.userInfo.userInfo.companyName,
            departmentCode: this.userInfo.userInfo.departmentCode,
            departmentName: this.userInfo.userInfo.departmentName,
            tenantCode: this.userInfo.userInfo.tenantCode,
            sourceType: '1',
          };
        },
      }),
    },
    data() {
      return {
        footerTotalCols: {
          amount: ['applyClAmount', 'clAmount', 'marginAmount', 'paidAmount', 'acceptanceAmount'],
        }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        action: API.IMPORT,
        query: {
          contractNo: null,
          // sourceType: 1,
          businessCompanyCode: null,
          businessDepartmentCode: null,
          applyNo: null,
          applyDateStart: null,
          applyDateEnd: null,
          beneficiary: null,
          applyUserName: null,
          clCode: null,
          issueDateStart: null,
          issueDateEnd: null,
          clType: null,
          bankId: null,
          currencyCode: null,
          acceptDateBefore: null,
          acceptDateAfter: null,
          statusFlag: null,
          acceptNegotiationStatus: null,
          // accountStatus: null,
          negotiationDateStart: null,
          negotiationDateEnd: null,
          issueType: null,
          // isAccpetComplete: null,
          // isPayComplete: null,
          clAmountMin: null,
          clAmountMax: null,
          // delayPaymentType1: null,
          // delayPaymentType2: null,
          // delayPaymentType3: null,
          // delayPaymentTypes: [],
          acceptAmountMin: null,
          acceptAmountMax: null,
          applyClAmountMin: null,
          applyClAmountMax: null,
          // accIsLockExchangeRate: null,
          // isLockExchangeRate: null,
          // unDelayPayment: false, //未押汇
          // voucherCode: null,
          revocationDateEnd: null,
          revocationDateStart: null,
        },
        companyList: [],
        departmentList: [],
        bankList: [],
        multipleSelection: [],
        // 表格展示字段
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          // {
          //   // 切换
          //   type: 'expand',
          //   visible: true,
          //   width: '50',
          //   fixed: 'left',
          // },
          {
            field: 'businessCompanyName',
            title: 'searchIssueCredit.table.companyName',
            visible: true,
          },
          {
            field: 'businessDepartmentName',
            title: 'searchIssueCredit.table.departmentName',
            visible: true,
          },
          { field: 'applyNo', title: 'searchIssueCredit.table.applyNo', visible: true, width: 120 },
          {
            field: 'applyUserName',
            title: 'searchIssueCredit.table.applyUserName',
            visible: true,
          },
          {
            field: 'statusFlag',
            title: 'searchIssueCredit.table.statusFlag',
            visible: true,
            dictType: 'cl-status-flag',
          },
          {
            field: 'acceptNegotiationStatus',
            visible: true,
            title: '承兑&议付状态',
            dictType: 'accept-negotiation',
          },
          {
            field: 'applyDate',
            title: 'searchIssueCredit.table.applyDate',
            visible: true,
          },
          {
            field: 'clType',
            title: 'searchIssueCredit.table.clType',
            visible: true,
            dictType: 'cl-clType',
          },
          {
            field: 'applyClAmount',
            title: 'searchIssueCredit.table.applyClAmount',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'clAmount',
            title: 'searchIssueCredit.table.clAmount',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'marginAmount',
            title: 'tFundCreditLetter.column.marginAmount',
            visible: true,
          },
          {
            field: 'currencyCode',
            title: 'searchIssueCredit.table.currencyName',
            visible: true,
            dictType: 'all_currency',
          },
          { field: 'clCode', title: 'searchIssueCredit.table.clCode', visible: true, width: 120 },
          {
            field: 'issueDate',
            title: 'searchIssueCredit.table.issueDate',
            visible: true,
          },
          {
            field: 'branchName',
            title: 'searchIssueCredit.table.bankBranch',
            visible: true,
          },
          {
            field: 'issueType',
            title: 'searchIssueCredit.table.issueType',
            visible: true,
            dictType: 'cl-issueType',
          },
          {
            field: 'partnerName',
            title: 'searchIssueCredit.table.partnerName',
            visible: true,
          },
          // {
          //   field: 'acceptanceAmount',
          //   title: 'searchIssueCredit.table.acceptanceAmount',
          //   visible: true,
          //   width: 120,
          // },
          {
            field: 'paidAmount',
            title: 'searchIssueCredit.table.paidAmount',
            visible: true,
            format: 'formatAmountRound',
          },
          // {
          //   field: 'isAccpetComplete',
          //   title: 'searchIssueCredit.table.isAccpetComplete',
          //   visible: true,
          //   width: 120,
          //   dictType: 'yes-no',
          // },
          // {
          //   field: 'isPayComplete',
          //   title: 'searchIssueCredit.table.isPayComplete',
          //   visible: true,
          //   width: 120,
          //   dictType: 'yes-no',
          // },
          // {
          //   field: 'accountStatus',
          //   title: 'searchIssueCredit.table.accountStatus',
          //   visible: true,
          //   width: 120,
          //   dictType: 'post_status',
          // },
          // 凭证号
          // { field: 'voucherCode', title: '凭证号', visible: true, width: 120 },
          { field: 'revocationDate', title: '撤销日期', visible: true },
        ],
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.getCompany();
        this.getData();
        this.getButtonList();
      });
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e || [];
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          console.log(res);
          this.columnList = this.columnListDefault;
          // if (res.length > 0) {
          //   this.columnList = res.map((item) => {
          //     let obj = { ...this.columnListDefault.find((it) => it.field == item.field), ...item };
          //     return obj;
          //   });
          // }
        });
      },
      getDelayPaymentType(val) {
        let list = [
          {
            label: this.$t('acceptanceDetail.goodsTable.delayPaymentType0'), //不押汇
            value: '0',
          },
          {
            label: this.$t('acceptanceDetail.goodsTable.delayPaymentType1'), //部门不押汇公司押汇
            value: '1',
          },
          {
            label: this.$t('acceptanceDetail.goodsTable.delayPaymentType2'), //部门押汇公司不押汇
            value: '2',
          },
          {
            label: this.$t('acceptanceDetail.goodsTable.delayPaymentType3'), //部门押汇且公司押汇
            value: '3',
          },
        ];
        return list.find((it) => it.value == val).label;
      },
      //公司代码
      async getCompany() {
        const selectStatus = await this.$axios.get(
          BASE_API.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
        this.departmentList = [];
        this.query.businessDepartmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 获取部门
      getdepartmentList(companyCode) {
        this.$axios.post(BASE_API.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 获取列表数据
      getData() {
        let query = Object.assign({}, this.query, true);
        if (query.beneficiary) query.beneficiary = query.beneficiary[0].beneficiary;
        if (query.branchCode) query.branchCode = query.branchCode[0].branchCode;
        // let delayPaymentTypes = [];
        // let delayPaymentType = {
        //   delayPaymentType1: 1,
        //   delayPaymentType2: 2,
        //   delayPaymentType3: 3,
        // };
        // Object.keys(delayPaymentType).map((item) => {
        //   query[item] = query[item] ? delayPaymentType[item] : null;
        //   if (query[item]) {
        //     return delayPaymentTypes.push(query[item]);
        //   }
        // });
        // query.delayPaymentTypes = delayPaymentTypes;
        // query.isAccpetComplete = query.isAccpetComplete ? '1' : null;
        // query.isPayComplete = query.isPayComplete ? '1' : null;
        // query.accIsLockExchangeRate = query.accIsLockExchangeRate ? '1' : null;
        // query.isLockExchangeRate = query.isLockExchangeRate ? '1' : null;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...query, pageNum, pageSize };
        // const params = { ...query };
        this.load = true;
        this.$axios.post(API.QUERY_CREDITLETTER_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 按钮
      chooseClick(type) {
        console.log(type, '11111');
        if (type == 'import') {
          this.handleImport();
        } else if (type == 'submit') {
          this.submit();
        } else if (type == 'copy') {
          this.copyLC();
        } else {
          this.goNewPage(type);
        }
      },
      //批量提交
      submit(params = { ids: this.multipleSelection.map((it) => it.id) }) {
        loading.startLoading();
        this.$axios
          .post(API.BATCH_SUBMIT, params)
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.getData();
            } else {
              //包含code=10或者其他
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  params.cancelValidate = true;
                  this.submit(params);
                },
              });
            }
          })
          .catch(() => loading.endLoading());
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      // 复制信用证
      copyLC() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('searchIssueCredit.msg.onlyOne'),
            type: 'error',
          });
          return;
        }

        this.goApply('copy');
      },
      //跳转页面
      goNewPage(type) {
        let path = {};
        let row = this.multipleSelection[0];
        //信用证证状态为空或者为已保存状态时可用
        if (type == 'addApply') {
          path = {
            path: '/letterOfCredit/applicationForCredit',
            name: 'applicationForLC',
            meta: {
              keepAlive: true,
            },
            query: {
              isEdit: 'Y',
            },
          };
        } else if (type == 'edit') {
          this.goApply();
          return;
        } else if (type == 'issue') {
          if (row && row.statusFlag !== '004') {
            this.$message({
              showClose: true,
              message: this.$t('searchIssueCredit.msg.issuingTip'),
              type: 'error',
            });
            return;
          }
          path = {
            path: '/letterOfCredit/issuing',
            name: 'issuingLC',
            meta: {
              keepAlive: true,
            },
            query: {},
          };
          if (this.multipleSelection.length != 1) {
            this.$message({
              showClose: true,
              message: this.$t('searchIssueCredit.msg.onlyOne'),
              type: 'error',
            });
            return;
          } else {
            path.query = {
              isEdit: 'Y',
              applicationId: row.id,
              operateType: 'issue',
            };
          }
        } else if (type == 'accept') {
          if (row && ['005', '007'].indexOf(row.statusFlag) == -1) {
            this.$message({
              showClose: true,
              message: this.$t('searchIssueCredit.msg.acceptanceTip'),
              type: 'error',
            });
            return;
          }
          path = {
            path: '/letterOfCredit/acceptance',
            name: 'acceptanceLC',
            meta: {
              keepAlive: true,
            },
            query: {},
          };
          if (this.multipleSelection.length != 1) {
            this.$message({
              showClose: true,
              message: this.$t('searchIssueCredit.msg.onlyOne'),
              type: 'error',
            });
            return;
          } else {
            path.query = {
              isEdit: 'Y',
              applicationId: row.id,
              clType: row.clType,
            };
          }
        } else if (type === 'delete') {
          this.del('1');
        } else if (type === 'cancel') {
          this.del('2');
        } else if (type == 'export') {
          if (this.tableData.length === 0) {
            return this.tips('noExport');
          }
          this.handleExport();
        } else if (type == 'syncVoucher') {
          // 批量过账
          this.batchSyncVoucher(API.BATCH_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'signSyncVoucher') {
          // 批量标记过账
          this.batchSyncVoucher(API.BATCH_SIGN_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'genarateVoucher') {
          this.batchGenarateVoucher(
            'AE_AP_CREDIT_BILL',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else {
          return;
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      goApply(flag) {
        let path = {
          path: '/letterOfCredit/applicationForCredit',
          name: 'applicationForLC',
          meta: {
            keepAlive: true,
          },
          query: {
            isEdit: 'Y',
          },
        };
        let row = this.multipleSelection[0];
        if (row) {
          if (this.multipleSelection.length != 1) {
            this.$message({
              showClose: true,
              message: this.$t('searchIssueCredit.msg.applicationButTip'),
              type: 'error',
            });
            return;
          } else if (this.multipleSelection.length == '1') {
            let statusFlag = row.statusFlag;
            // 复制按钮可以进入 并且可编辑
            if (statusFlag == '001' || statusFlag == '003' || flag == 'copy') {
              path.query = {
                isEdit: statusFlag != '002' || flag == 'copy' ? 'Y' : 'N',
                applicationId: row.id,
                flag,
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t('searchIssueCredit.msg.addApplyTip'),
                type: 'error',
              });
              return;
            }
          }
        }
      },
      //行项目样式
      rowStyle({ row }) {
        let newDate = new Date();
        let expiringDate = new Date(row.expiringDate);
        let date = (expiringDate - newDate) / 1000 / 60 / 60 / 24;
        if (date > 0 && date <= 7) {
          return {
            backgroundColor: 'rgb(255,227,190)',
          };
        }
      },
      // 列表双击
      dblclickEvent(value) {
        let path = {
          path: '/letterOfCredit/applicationForCredit',
          name: 'applicationForLC',
          meta: {
            keepAlive: true,
          },
          query: {
            isEdit: 'N',
            applicationId: value.row.id,
            clType: value.row.clType,
          },
        };
        if (['001', '002', '003'].indexOf(value.row.statusFlag) !== -1) {
          path.path = '/letterOfCredit/applicationForCredit';
          path.name = 'applicationForLC';
        } else if (['004'].indexOf(value.row.statusFlag) !== -1) {
          path.path = '/letterOfCredit/issuing';
          path.name = 'issuingLC';
        } else if (['005', '006', '007', '008', '009'].indexOf(value.row.statusFlag) !== -1) {
          path.path = '/letterOfCredit/acceptance';
          path.name = 'acceptanceLC';
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            console.log(path);
            this.$router.push(path);
          });
        });
      },
      // 导出
      async handleExport() {
        const idList = this.multipleSelection.map((item) => item.id);
        let data;
        if (!idList.length && !this.tableData) {
          this.$message.error('没有数据可以导出！');
          return;
        }
        const tableList = this.tableData.map((item) => item.id);
        console.log(tableList, '表格数据的id值');
        if (!idList.length) {
          this.isLoading = true;
          data = await this.$axios.post(API.EXPORT_CREDITLETTER, { ids: tableList });
          this.isLoading = false;
        } else {
          this.isLoading = true;
          data = await this.$axios.post(API.EXPORT_CREDITLETTER, { ids: idList });
          this.isLoading = false;
        }
        if (data.data.code === 0) {
          window.location.href = data.data.data;
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      },
      // 删除/撤销弹框
      del(specialFlag) {
        let canDelitems = [];
        this.multipleSelection.map((i) => {
          if (i.statusFlag == '001' || i.statusFlag == '003') {
            canDelitems.push(i);
          }
        });
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelectData');
        }
        if (canDelitems.length == 0) {
          return this.tips('noCanDelSelectData');
        }
        let items = canDelitems.map((i) => i.id);
        if (specialFlag == 1) {
          let message = '确认删除选中的信用证?';
          if (canDelitems.length !== this.multipleSelection.length) {
            message = this.$t('searchIssueCredit.tips.hasCannotDelTip');
          }
          this.$confirmAction(this.$t('confirm.delete'), message)
            .then(() => {
              this.handleDel(items, specialFlag);
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.handleDel(items, specialFlag);
        }
      },
      // 删除/撤销
      handleDel(idList) {
        const params = {
          idList,
        };
        this.$axios.post(API.DEL_CREDITLETTER, params).then((res) => {
          if (0 == res.data.code) {
            this.getData();
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`searchIssueCredit.tips.${info}`),
          type: 'error',
        });
      },

      // 修改当前页
      handleCurrentChange() {
        this.getData();
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
        console.log(this.multipleSelection, '选择行信息');
      },
    },
  };
</script>
<style lang="scss" scoped>
  // .payBill{

  // }
</style>
